<template>
  <div>
    <vx-card no-shadow title="Activities">
      <a-card>
        <a-tabs v-model="type_activity" @change="tabClick">
          <a-tab-pane v-if="hasPermission('activity.time-entry.list')" key="1" tab="Time">
              <a-card title="Filters">
                <div class="flex flex-col md:flex-row justify-between">
                  <div class="flex flex-col md:flex-row md:space-x-4">
                    <a-form-item has-feedback>
                      <a-date-picker
                        v-model="from_date"
                        @change="filterDate"
                        :format="dateFormat"
                        valueFormat="YYYY-MM-DD"
                        placeholder="From date"
                      />
                    </a-form-item>
                    <a-form-item has-feedback>
                      <a-date-picker
                        v-model="to_date"
                        @change="filterDate"
                        :format="dateFormat"
                        valueFormat="YYYY-MM-DD"
                        placeholder="To date"
                      />
                    </a-form-item>
                  </div>
                  <a-button 
                    type="primary"
                    ghost
                    icon="filter"
                    @click="showDrawer($refs.time)"
                    class="mt-5 md:mt-0"
                    style="border-radius: 3px !important;"
                  >
                    Filters
                  </a-button>
                </div>
              </a-card>
              <XTable
                class="mt-5"
                :model="model"
                ref="Activities"
                :options="{ placeholder:'Search time',noContent: 'No times',is_row_selection: false,is_load_req: true,temp_row: null }"
                :_query="[{ field: 'matter', condition: '=', value: this.$route.params.id  }]"
                @clickRow="(record)=>clickTempRow(record,`/activity/time-entry/${record.id}/`,'activity.time-entry.get')"
              >
                <span slot="action" slot-scope="text,record" class="flex space-x-3">
                   <a-dropdown>
                    <a-menu slot="overlay">
                      <a-menu-item v-if="hasPermission('activity.time-entry.get') && !text.record.is_used_in_invoice" key="1" @click="clickTempRow(text.record,`/activity/time-entry/${text.record.id}/`,'activity.time-entry.get')"> <feather-icon icon="EditIcon" class="pr-2" svg-classes="text-success w-4 h-4"></feather-icon> Edit</a-menu-item>
                      <a-menu-item v-if="hasPermission('activity.time-entry.delete')" key="2" @click="deleteTimeEntry(text.record)"> <feather-icon icon="TrashIcon" class="pr-2" svg-classes="text-danger w-4 h-4"></feather-icon>Delete</a-menu-item>
                    </a-menu>
                    <a-button @click="is_click_add_time = false" style="margin-left: 8px"> Actions <a-icon type="down" /> </a-button>
                   </a-dropdown>
                </span>
                <span slot="user" slot-scope="text,record" v-if="text.record.user">
                  {{ text.record.user.first_name }} {{ text.record.user.last_name }}
                </span>
                <span slot="NonBillable" slot-scope="text,record">
                  <template v-if="text.record.is_no_billable">
                    {{ Number.isInteger(text.record.rate * text.record.duration) ? text.record.rate * text.record.duration : (text.record.rate * text.record.duration).toFixed(4) }}
                  </template>
                </span>
                <span slot="billable" slot-scope="text,record">
                  <template v-if="!text.record.is_no_billable">
                    {{ Number.isInteger(text.record.rate * text.record.duration) ? text.record.rate * text.record.duration : (text.record.rate * text.record.duration).toFixed(4) }}
                  </template>
                </span>
                <span slot="duration" slot-scope="text,record">
                  {{ text.record.duration > 0 ? text.record.duration + 'h' : '' }}
                </span>
                <span slot="rate" slot-scope="text,record">
                  {{ text.record.rate > 0 ? Number.isInteger(text.record.rate) ? text.record.rate : (text.record.rate).toFixed(2) : text.record.rate = '0.00' }}
                </span>
                <span slot="matter" slot-scope="text,record" v-if="text.record.matter">
                  <a-popover>
                    <template slot="content">
                      <p>{{ text.record.matter.title }}</p>
                    </template>
                    <p style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden; width: 8rem;">
                      {{ text.record.matter.title }}
                    </p>
                  </a-popover>
<!--                  {{ text.record.matter.title }}-->
                </span>
                <span slot="invoice" slot-scope="text,record">
                  <feather-icon icon="CheckIcon" svg-classes="w-4 h-5 text-success" v-if="text.record.is_used_in_invoice"></feather-icon>
                  <feather-icon icon="XIcon" svg-classes="w-4 h-5 text-danger" v-else></feather-icon>
                </span>
                <span slot="date" slot-scope="text,record">
                  {{ setDateFormat(text.record.date) }}
                </span>
              </XTable>
          </a-tab-pane>
          <a-tab-pane v-if="hasPermission('activity.expense-entry.list')" key="2" tab="Expense">
              <a-card title="Filters">
                <div class="flex flex-col md:flex-row justify-between">
                  <div class="flex flex-col md:flex-row md:space-x-4">
                    <a-form-item has-feedback>
                      <a-date-picker
                        v-model="from_date"
                        @change="filterDate"
                        :format="dateFormat"
                        valueFormat="YYYY-MM-DD"
                        placeholder="From date"
                      />
                    </a-form-item>
                    <a-form-item has-feedback>
                      <a-date-picker
                        v-model="to_date"
                        @change="filterDate"
                        :format="dateFormat"
                        valueFormat="YYYY-MM-DD"
                        placeholder="To date"
                      />
                    </a-form-item>
                    <a-form-item has-feedback>
                      <a-select
                        allowClear
                        class="select w-full md:w-64"
                        placeholder="Expense type"
                        @change="filterExpenseType"
                      >
                        <a-select-option value="all">
                          All
                        </a-select-option>
                        <a-select-option :value="1">
                          Disbursement/Recoveries
                        </a-select-option>
                        <a-select-option :value="2">
                          Operational Expenses
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </div>
                  <a-button  type="primary"
                             icon="filter"
                             ghost
                             @click="showDrawer($refs.time)"
                             class="mt-5 md:mt-0"
                             style="border-radius: 3px !important;"
                  >
                    Filters
                  </a-button >
                </div>
              </a-card>
              <XTable
                class="mt-5"
                :model="model_expense"
                ref="expenseEntry"
                :options="{ placeholder:'Search expense',noContent: 'No expense',is_row_selection: false,is_load_req: true,temp_row: null }"
                :_query="[{ field: 'matter', condition: '=', value: this.$route.params.id  }]"
                @clickRow="(record)=>clickTempRow(record,`/activity/expense-entry/${record.id}/`,'activity.expense-entry.get')"
              >
              <span slot="action" slot-scope="text,record" class="flex space-x-3">
                   <a-dropdown>
                    <a-menu slot="overlay">
                      <a-menu-item v-if="hasPermission('activity.expense-entry.get') && !text.record.is_used_in_invoice" key="1" @click="clickTempRow(text.record,`/activity/expense-entry/${text.record.id}/`,'activity.expense-entry.get')"> <feather-icon icon="EditIcon" svg-classes="text-success w-4 h-4" />Edit</a-menu-item>
                      <a-menu-item v-if="hasPermission('activity.expense-entry.delete')" key="2" @click="deleteTimeEntry(text.record)"><feather-icon icon="TrashIcon" svg-classes="text-danger w-4 h-4" />Delete</a-menu-item>
                    </a-menu>
                    <a-button style="margin-left: 8px" @click="is_click_add_time = false"> Actions <a-icon type="down" /> </a-button>
                   </a-dropdown>
              </span>
                <span slot="expense_type" slot-scope="text,record">
                <template v-if="text.record.expense_type === 1">
                     Time entry category
                </template>
                 <template v-else>
                      Expense category
                </template>
              </span>
                <span slot="rate" slot-scope="text,record">
                  {{ text.record.rate > 0 ? (text.record.rate).toFixed(2) : '0.00' }}
              </span>
                <span slot="user" slot-scope="text,record">
                  {{ `${text.record.user.first_name} ${text.record.user.last_name}` }}
              </span>
                <span slot="quantity" slot-scope="text,record">
                {{ text.record.quantity > 0 ? (text.record.quantity).toFixed(2) : '0.00' }}
              </span>
                <span slot="amount" slot-scope="text,record">
                {{  Number.isInteger(text.record.amount) ? text.record.amount : (text.record.amount).toFixed(2)  }}
              </span>
                <span slot="matter" slot-scope="text,record" v-if="text.record.matter">
                {{ text.record.matter.title }}
              </span>
                <span slot="category" slot-scope="text,record" v-if="text.record.category">
                {{ text.record.category.name }}
              </span>
                <span slot="date" slot-scope="text,record" v-if="text.record.date">
                {{ setDateFormat(text.record.date) }}
              </span>
                <span slot="expense_type" slot-scope="text,record">
                <template v-if="text.record.expense_type === 1">Disbursement</template>
                <template v-else>Expense</template>
              </span>
                <span slot="used_invoices" slot-scope="text,record">
                  <feather-icon icon="CheckIcon" svg-classes="w-4 h-5 text-success" v-if="text.record.is_used_in_invoice"></feather-icon>
                  <feather-icon icon="XIcon" svg-classes="w-4 h-5 text-danger" v-else></feather-icon>
              </span>
              </XTable>
          </a-tab-pane>
          <a-tab-pane v-if="hasPermission('activity.expense-entry.category.list')" key="3" tab="Expense Categories">
              <a-card title="Filters">
                <div class="flex flex-col md:flex-row justify-between">
                  <a-radio-group v-model="type_category" button-style="solid" class="flex md:flex-row self-center" style="white-space: nowrap">
                    <a-radio-button :value="'all'" @click="filterStatus('all')">
                      All
                    </a-radio-button>
                    <a-radio-button :value="1" @click="filterStatus(1)">
                      Disbursement
                    </a-radio-button>
                    <a-radio-button :value="2" @click="filterStatus(2)">
                      Operational
                    </a-radio-button>
                  </a-radio-group>
                  <a-button  type="primary"
                             icon="filter"
                             ghost
                             @click="showDrawer($refs.drawerCategory)"
                             class="mt-5 md:mt-0"
                             style="border-radius: 3px !important;"
                  >
                    Filters
                  </a-button>
                </div>
              </a-card>
              <XTable
                class="mt-5"
                :model="model_category"
                ref="expenseCategory"
                :options="{ placeholder:'Search category',noContent: 'No category',is_row_selection: false,is_load_req: true,temp_row: null }"
                @clickRow="(record)=>editCategory(record,`/activity/expense-entry/category/${record.id}/`,'activity.expense-entry.category.list')"
                @refresh="refresh"
                @search="searchCategory"
                @rows="rows"
              >
                <span slot="action" slot-scope="text,record" class="flex space-x-3">
                   <a-dropdown>
                    <a-menu slot="overlay">
                      <a-menu-item v-if="hasPermission('activity.expense-entry.category.get')" key="1" @click="editCategory(text.record,`/activity/expense-entry/category/${text.record.id}/`,'activity.expense-entry.category.get')"> <a-icon type="edit" />Edit</a-menu-item>
                      <a-menu-item v-if="hasPermission('activity.expense-entry.category.delete')" key="2" @click="deleteTimeEntry(text.record)"> <a-icon type="delete" />Delete</a-menu-item>
                    </a-menu>
                    <a-button @click="is_click_add_time = false" style="margin-left: 8px"> Actions <a-icon type="down" /> </a-button>
                   </a-dropdown>
                </span>
                <span slot="expense_type" slot-scope="text,record">
                  <template v-if="text.record.expense_type === 1">
                    Disbursement/Recoveries
                  </template>
                  <template v-else>
                    Operational Expense
                  </template>
                </span>
                <span slot="rate" slot-scope="text,record">
                  {{ text.record.rate > 0 ? (text.record.rate).toFixed(2) : '0.00' }}
                </span>
              </XTable>
          </a-tab-pane>
          <a-tab-pane v-if="hasPermission('activity.expense-entry.category.list')" key="4" tab="Time Categories">
            <XTable
              class="mt-5"
              :model="model_category_times"
              ref="timesCategory"
              :options="{ placeholder:'Search category',noContent: 'No category',is_row_selection: false,is_load_req: true ,temp_row: null }"
              @refresh="refresh"
              @search="searchCategory"
              @rows="rows"
            >
              <span slot="action" slot-scope="text,record" class="flex space-x-3">
                <a-dropdown>
                  <a-menu slot="overlay">
<!--                    v-if="hasPermission('activity.time-entry.category.get')"-->
                    <a-menu-item key="1" @click="category_type=null;clickTempRow(text.record,`/activity/time-entry/category/${text.record.id}/`,'activity.expense-entry.category.get')"> <a-icon type="edit" />Edit</a-menu-item>
                    <a-menu-item key="2" @click="deleteTimeEntry(text.record)"> <a-icon type="delete" />Delete</a-menu-item>
                  </a-menu>
                  <a-button @click="is_click_add_time = false" style="margin-left: 8px"> Actions <a-icon type="down" /> </a-button>
                </a-dropdown>
              </span>
              <span slot="rate" slot-scope="text,record">
                {{ text.record.rate > 0 ? (text.record.rate).toFixed(2) : '0.00' }}
              </span>
            </XTable>
          </a-tab-pane>
          <div slot="tabBarExtraContent" class="btn_add w-full space-x-0 md:space-x-2">
            <a-dropdown v-if="hasPermission('activity.time-entry.create') || hasPermission('activity.expense-entry.create') || hasPermission('activity.expense-entry.category.create')">
              <a-menu @click="handleClickChange" slot="overlay">
<!--                <feather-icon icon="UserIcon" class="mr-3" svg-classes="w-4 h-4"/>-->
                <a-menu-item v-if="hasPermission('activity.time-entry.create')" key="1" @click="addActivities">Time Entry</a-menu-item>
                <a-menu-item v-if="hasPermission('activity.expense-entry.create')" key="2" @click="addActivitiesEntry">Expense</a-menu-item>
                <a-menu-item v-if="hasPermission('activity.expense-entry.category.create')" key="3" @click="addCategoryType">Expense Category</a-menu-item>
                <a-menu-item v-if="hasPermission('activity.expense-entry.category.create')" key="4" @click="addCategoryType">Time Category</a-menu-item>
              </a-menu>
              <a-button type="primary" style="margin-left: 8px;"> Create New <a-icon type="down" /></a-button>
            </a-dropdown>
          </div>
        </a-tabs>
      </a-card>
    </vx-card>

    <Drawer
      ref="drawerCategory"
      :form="formCategoryType"
      :ele="$refs.expenseCategory"
      @filter="filterCategory"
      :query="[
        { field : 'expense_type', value: formCategoryType.getFieldValue('expense_type'), condition: '='},
        { field : 'name'        , value: formCategoryType.getFieldValue('name'), condition: formCategoryType.getFieldValue('condition_name') }
      ]"
    >
      <template>
        <a-form-item label="Category type">
          <a-radio-group class="flex" v-decorator="['expense_type']">
            <a-radio :value="1">
              Disbursement
            </a-radio>
            <a-radio :value="2">
              Operational
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-divider/>
        <a-form-item label="Condition" has-feedback>
          <a-select
            placeholder="condition"
            style="width: 100%"
            allowClear
            class="select"
            v-decorator="['condition_name']"
          >
            <a-select-option value="=">
              Equal
            </a-select-option>
            <a-select-option value="like">
              Like
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Name">
          <a-input
            v-decorator="['name']"
            :disabled="!formCategoryType.getFieldValue('condition_name')"
          />
        </a-form-item>
        <div
          :style="{
                  position: 'absolute',
                  left: 0,
                  bottom: 0,
                  width: '100%',
                  padding: '10px 16px',
                  background: '#fff',
                  textAlign: 'left',
                  direction:'rtl',
                  zIndex: 1,
               }"
        >
          <a-button type="primary" html-type="submit" style="border-radius: 3px">
            Save filter
          </a-button>
        </div>
      </template>
    </Drawer>

    <Drawer
      ref="time"
      :form="type_activity === '1' ? form : formEntry"
      :ele="type_activity  === '1' ? $refs.Activities : $refs.expenseEntry"
      @filter="filterCategory"
      :query="[
        { field : 'rate'    , value : type_activity === '1' ? form.getFieldValue('rate')   : formEntry.getFieldValue('rate')    , condition: 'like' },
        { field : 'user'    , value : type_activity === '1' ? form.getFieldValue('user')   : formEntry.getFieldValue('user')    , condition: '='    },
        { field : 'matter'  , value : type_activity === '1' ? form.getFieldValue('matter') : formEntry.getFieldValue('matter')  , condition: '='    },
        { field : 'amount'  , value : formEntry.getFieldValue('amount')  , condition: 'like' },
        { field : 'category', value : formEntry.getFieldValue('category') , condition: '=' },
      ]"
    >
      <template>
        <selectSearch
          :required="false"
          url="/matter/query/"
          :options="optionSearchMatter"
          field="matter"
          label="Matters"
          class="self-center mt-8 md:mt-0 w-full"
          :is_include_matter="true"
          @selectSearch="handleSearch"
        />
        <SelectOption
          url="/account/list/"
          label="User"
          field="user"
          method="get"
          placeholder="Find A User"
          class="w-full"
        />
        <a-form-item label="Rate" has-feedback>
          <a-input
            v-decorator="['rate',{ rules: [{ required: false, message: 'Please input your username!' },{ pattern:/[+-]?([0-9]*[.])?[0-9]+/,message:'Select a valid rate.', required: false }] }]"
            placeholder="0.00"
            autocomplete="off"
          />
        </a-form-item>
        <a-form-item label="category" has-feedback v-if="type_activity === '2'">
          <a-select
            v-decorator="['category']"
            allowClear
            placeholder="Expense category"
            show-search
            :filter-option="filterOption"
          >
            <a-select-option v-for="item in expense_categories" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Total amount" v-if="type_activity === '2'">
          <a-input
            v-decorator="['amount']"
            placeholder="0.00"
          >
            <a-icon slot="prefix" type="dollar" />
          </a-input>
        </a-form-item>
        <div
          :style="{
                  position: 'absolute',
                  left: 0,
                  bottom: 0,
                  width: '100%',
                  padding: '10px 16px',
                  background: '#fff',
                  textAlign: 'left',
                  direction:'rtl',
                  zIndex: 1,
               }"
        >
          <a-button type="primary" html-type="submit" style="border-radius: 3px">
            Save filter
          </a-button>
        </div>
      </template>
    </Drawer>

    <a-modal
      centered
      :width="850"
      :visible="openActivities"
      :title="is_mode_edit ? 'Edit time entry' : 'New time entry'"
      @cancel="onCancel"
    >
      <a-form :form="form" @submit.prevent="handleSubmit">
        <div class="flex flex-col md:flex-row space-x-0 md:space-x-8">
          <div class="w-full md:w-1/2">
            <div class="flex flex-row space-y-0 space-x-4">
              <a-form-item label="Duration" has-feedback>
                <a-input
                  v-decorator="['duration',{ rules: [{ required: false, message: 'Please Enter Time field.' },{ pattern: /(?<=^| )\d+(\.\d+)?(?=$| )|(?<=^| )\.\d+(?=$| )/,message:'You can only enter numbers', required: false }] }]"
                  placeholder="recorded Time"
                  autocomplete="none"
                  :disabled="!stop_time"
                  addon-after="hour"
                  class="recorded_time"
                />
              </a-form-item>
              <Timer @Timer="(timing)=>timer(timing,form,'duration')" @startTime="startTime" :time="time" ref="timer" class="timer self-center mt-2"/>
            </div>
            <SelectOption ref="user" url="/account/list/"  @SelectUser="SelectUser" label="User" field="user" :required="true" method="get" placeholder="Find A User" class="w-full"/>
            <a-form-item label="Headline" has-feedback>
              <a-select
                v-decorator="['category',{ rules: [{ required: true, message: 'This field is required.' }] }]"
                class="select select-expense-type"
                allowClear
                placeholder="Times category"
                option-label-prop="label"
                show-search
                :filter-option="filterOption"
                @change="selectExpenseType"
              >
<!--                <div slot="dropdownRender" slot-scope="menu">-->
<!--                  <v-nodes :vnodes="menu" />-->
<!--                  <a-divider style="margin: 4px 0;" />-->
<!--                  <div-->
<!--                    style="padding: 8px 8px; cursor: pointer;color: #3A3DBE"-->
<!--                    @click="addCategoryToExpense"-->
<!--                  >-->
<!--                    <a-icon type="plus-circle" />  Create new time category-->
<!--                  </div>-->
<!--                </div>-->
                <a-select-option v-for="item in time_categories" :label="item.name" :value="item.id">
                  {{ item.name }} ({{'$' + item.rate }})
                </a-select-option>
                <template #notFoundContent>
                  <div class="text-center">
                    You need to create a "Time Category" first.
                  </div>
                </template>
              </a-select>
            </a-form-item>
            <a-form-item label="Description" has-feedback>
              <!-- <a-textarea -->
                <!-- v-decorator="['description',{ rules: [{ required: false, message: 'Please input your username!' }] }]" -->
                <!-- :rows="7" -->
              <!-- /> -->
              <!-- Since vue-editor does not emit `input` event in a way
              v-decorator can collect its value, we must do it manually. -->
              <vue-editor 
                v-decorator="[
                  'description',
                  {
                    initialValue: '',
                    valuePropName: 'value',
                    trigger: 'input',
                    getValueFromEvent: v => v,
                  }
                ]"
                :editorToolbar="customToolbar"
                class="w-full h-full"
              />
            </a-form-item>
          </div>
          <div class="w-full md:w-1/2">
            <selectSearch
              :required="true"
              url="/matter/query/"
              :options="optionSearchMatter"
              :filterResponsibleOrigination="true"
              class="self-center mt-8 md:mt-0 w-full"
              :is_include_matter="true"
              @selectSearchValue="handleMatterActivity"
              ref="activityMatter"
            />
            <a-form-item label="Date" has-feedback>
              <a-date-picker
                v-decorator="['date',{ initialValue:new Date().toISOString().split('T')[0],rules: [{ required: true, message: 'This field is required.' }] }]"
                placeholder="dd/mm/yyyy"
                :format="dateFormat"
                valueFormat="YYYY-MM-DD"
              />
            </a-form-item>
            <div class="flex space-x-2">
              <a-form-item label="Rate" has-feedback>
                <a-input
                  v-decorator="['rate',{ initialValue: '0.00',rules: [{ required: false, message: 'Please input your username!' },{ pattern:/[+-]?([0-9]*[.])?[0-9]+/,message:'Select a valid rate.', required: false }] }]"
                  placeholder="0.00"
                  class="ant-input"
                  autocomplete="off"
                  @blur="convertToDecimal('rate',form)"
                />
              </a-form-item>
              <p class="self-center md:self-end font-semibold text-sm text-gray-400 mt-3 md:mt-0">Default rate</p>
            </div>
            <div class="flex items-center">
              <a-form-item>
                <a-checkbox
                  v-decorator="['is_no_billable',{ valuePropName:'checked' }]"
                >
                  non-billable
                </a-checkbox>
              </a-form-item>
              <a-icon class="self-start md:self-center mt-4 md:mt-0" type="info-circle" theme="twoTone" two-tone-color="#3A3DBE"/>
            </div>
          </div>
        </div>
        <template v-if="is_mode_edit ? hasPermission('activity.time-entry.edit') : hasPermission('activity.time-entry.create')">
          <a-divider/>
          <div class="flex space-x-2">
            <a-button type="primary" html-type="submit" style="border-radius: 3px !important;">
              Save Entry
            </a-button>
            <a-button type="primary" ghost @click="onCancel" style="border-radius: 3px !important;">
              Cancel
            </a-button>
          </div>
        </template>
      </a-form>
    </a-modal>

    <a-modal
      centered
      :width="800"
      :visible="openExpenseEntry"
      :title="is_mode_edit ? 'Edit Expense Entry' : 'New Expense Entry'"
      @cancel="onCancelEntry"
    >
      <a-form :form="formEntry" @submit.prevent="handleSubmitExpense">
        <a-form-item label="Expense type">
          <a-radio-group @change="handleChangeExpense" class="flex flex-col space-y-4" v-decorator="['expense_type',{initialValue:1}]">
            <a-radio :value="1" class="flex items-center">
              <div class="flex space-x-1">
                <strong>Disbursement/Recoveries</strong>
              </div>
            </a-radio>
            <a-radio :value="2" class="flex items-center">
              <div class="flex space-x-1">
                <strong>Operational Expense</strong>
              </div>
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="Category" has-feedback>
          <a-select
            v-decorator="['category',{ rules: [{ required: false, message: 'This field is required.' }] }]"
            class="select select-expense-type"
            allowClear
            placeholder="Expense category"
            option-label-prop="label"
            show-search
            :filter-option="filterOption"
            @change="selectExpenseType"
            :loading="loadingCategory"
          >
            <div slot="dropdownRender" slot-scope="menu">
              <v-nodes :vnodes="menu" />
              <a-divider style="margin: 4px 0;" />
              <div
                style="padding: 8px 8px; cursor: pointer;color: #3A3DBE"
                @click="addCategoryToExpense"
              >
                <a-icon type="plus-circle" />  Create new expense category
              </div>
            </div>
            <a-select-option v-for="item in expense_categories.filter(item => item.expense_type === category_expense)" :label="item.name" :value="item.id">
              {{ item.name }} ({{'$' + item.rate }})
            </a-select-option>
          </a-select>
        </a-form-item>
        <div class="flex flex-col md:flex-row space-x-0 md:space-x-4">
          <div class="w-full md:w-1/2">
            <div class="flex space-x-4 ">
              <a-form-item label="Quantity" class="w-1/3" has-feedback>
                <a-input
                  v-decorator="['quantity',{ initialValue: '1.00',rules: [{ required: false, message: 'Please input your username!' }] }]"
                  autocomplete="off"
                  class="ant-input"
                  @blur="convertToDecimal('quantity',formEntry)"
                  @keyup="setFieldRateQuantity"
                />
              </a-form-item>
              <a-form-item label="Rate"  class="w-2/3" has-feedback>
                <a-input
                  v-decorator="['rate',{ rules: [{ required: true, message: 'This field is required.' },{ pattern:/[+-]?([0-9]*[.])?[0-9]+/,message:'Enter a number.', required: true }] }]"
                  placeholder="Rate or until cost"
                  autocomplete="none"
                  @blur="convertToDecimal('rate',formEntry)"
                  @keyup="setFieldRateQuantity"
                >
                  <a-icon slot="prefix" type="dollar" />
                </a-input>
              </a-form-item>
            </div>
<!--            <a-form-item label="Vendor" has-feedback>-->
<!--              <a-input-->
<!--                v-decorator="['vendor',{ rules: [{ required: false, message: 'Please input your username!' }] }]"-->
<!--              />-->
<!--            </a-form-item>-->
            <selectSearch
              ref="client"
              :options="{ field:'vendor', label:'Vendor', is_add_extra_footer:false }"
            />
            <a-form-item label="Description" has-feedback>
              <!-- <a-textarea
                v-decorator="['description',{ rules: [{ required: false, message: 'This Field is required.' }] }]"
                :rows="7"
              /> -->
              <vue-editor 
                v-decorator="[
                  'description',
                  {
                    initialValue: '',
                    valuePropName: 'value',
                    trigger: 'input',
                    getValueFromEvent: v => v,
                  }
                ]"
                :editorToolbar="customToolbar"
                class="w-full h-full"
              />
            </a-form-item>
          </div>
          <div class="w-full md:w-1/2">
            <a-form-item label="Total amount" has-feedback>
              <a-input
                v-decorator="['amount',{ rules: [{ required: false }] }]"
                placeholder="0.00"
                @blur="convertToDecimal('amount',formEntry)"
                @keyup="setFieldAmount"
              >
                <a-icon slot="prefix" type="dollar" />
              </a-input>
            </a-form-item>
            <selectSearch
              :required="category_expense === 1"
              :disabled="category_expense === 2"
              url="/matter/query/"
              :filterResponsibleOrigination="true"
              :options="optionSearchMatter"
              class="self-center mt-8 md:mt-0 w-full"
              :is_include_matter="true"
              @selectSearch="handleSearch"
            />
            <SelectOption
              url="/account/list/"
              label="User"
              field="user"
              :required="true"
              method="get"
              placeholder="Find A User"
              class="w-full"
              :is_initial_value="true"
              @loaded="handleUsersLoaded"
            />
            <a-form-item label="Date" has-feedback>
              <a-date-picker
                v-decorator="['date',{ initialValue: new Date().toISOString().split('T')[0],rules: [{ required: true, message: 'This Field is required.' }] }]"
                autocomplete="off"
                :format="dateFormat"
                valueFormat="YYYY-MM-DD"
              >
              </a-date-picker>
            </a-form-item>
            <a-form-item v-show="formEntry.getFieldValue('expense_type') === 1" label="Reference" has-feedback>
              <a-input
                v-decorator="['reference',{ rules: [{ required: false }] }]"
                placeholder="Enter cheque reference number"
              />
            </a-form-item>
          </div>
        </div>
        <template v-if="is_mode_edit ? hasPermission('activity.expense-entry.edit') : hasPermission('activity.expense-entry.create')">
          <a-divider/>
          <div class="flex space-x-2">
            <a-button type="primary" html-type="submit" style="border-radius: 3px !important;">
              Save entry
            </a-button>
            <a-button type="primary" ghost @click="onCancelEntry" style="border-radius: 3px !important;">
              Cancel
            </a-button>
          </div>
        </template>
      </a-form>
    </a-modal>

    <a-modal
      centered
      :width="800"
      :visible="openCategoryType"
      :title="category_type === '3' ? 'New Expense Category' : 'New Time Category'"
      :zIndex="1500"
      @cancel="onCancelCategoryType"
    >
      <a-form :form="formCategoryType" @submit.prevent="handleCategoryType">

        <a-form-item v-if="category_type === '3'" label="Category type">
          <a-radio-group class="flex" v-decorator="['expense_type',{initialValue:1}]">
            <a-radio :value="1">
              Disbursement/Recoveries
            </a-radio>
            <a-radio :value="2">
              Operational Expense
            </a-radio>
          </a-radio-group>
        </a-form-item>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
          <a-form-item label="Name">
            <a-input
              v-decorator="['name',{ rules: [{ required: true, message: 'This Field is required.' }] }]"
              :maxLength="35"
            />
          </a-form-item>
          <a-form-item v-if="category_type === '3'" label="Billing Method">
              <a-select dropdownClassName="billing-method" v-decorator="['billing_method',{initialValue:1}]">
                <a-select-option :value="1">
                  User default rate
                </a-select-option>
                <a-select-option :value="2">
                  Custom rate
                </a-select-option>
                <a-select-option :value="3">
                  Flat Rate
                </a-select-option>
              </a-select>
            </a-form-item>
          <a-form-item label="Rate">
            <a-input
              autocomplete="none"
              class="recorded_time"
              @blur="convertToDecimal('rate',formCategoryType)"
              v-decorator="['rate']"
            />
          </a-form-item>
        </div>

        <template v-if="is_mode_edit ? hasPermission('activity.expense-entry.category.edit') : hasPermission('activity.expense-entry.category.create')">
          <div class="flex space-x-2 mt-5">
            <a-button type="primary" html-type="submit" style="border-radius: 3px">
              Save category
            </a-button>
            <a-button type="primary" ghost @click="onCancelCategoryType" style="border-radius: 3px">
              Cancel
            </a-button>
          </div>
        </template>
      </a-form>
    </a-modal>

    <deleteItem
      :url="`/activity/time-entry/${temp_row}/`"
      subject="Time Entry"
      :ele="$refs.Activities"
      ref="deleteTimeEntry"
    />

    <deleteItem
      :url="`/activity/expense-entry/category/${temp_row}/`"
      subject="Expense category"
      :ele="$refs.expenseCategory"
      ref="deleteExpenseCategory"
    />

    <deleteItem
      :url="`/activity/expense-entry/${temp_row}/`"
      subject="Expense entry"
      :ele="$refs.expenseEntry"
      ref="deleteExpenseEntry"
    />

    <deleteItem
      :url="`/activity/time-entry/category/${temp_row}/`"
      subject="Time entry"
      :ele="$refs.timesCategory"
      ref="deleteTimeCategory"
    />

  </div>

</template>

<script>
import XTable from '../../components/x-table/XTable'
import * as TableCol from './activitiesTbl'
import * as TableColCategory from './categoryTbl'
import * as TableColExpense from './expenceTbl'
import * as TableColCategoryTimes from './categoryTimesTbl'
import SelectOption from "../forms/SelectOptionSingle"
import selectSearch from "@/views/forms/selectSearch";
import Timer from "@/layouts/components/timer/Timer";
import deleteItem from '../communications/deleteItem'
import mixin from '../mixin/mixin'
import axios from "@/axios";
import Drawer from '../drawer/Drawer'
import { VueEditor } from "vue2-editor"

export default {
  name: "ActivitesList",
  mixins:[mixin],
  props:{
    hasFilterMatter:{
      type: Boolean,
      default: false
    }
  },
  components:{
    XTable,
    selectSearch,
    SelectOption,
    Timer,
    deleteItem,
    Drawer,
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    },
    VueEditor,
  },
  data() {
    return {
      openActivities    : false,
      openExpenseEntry  : false,
      openCategoryType  : false,
      formEntry         : this.$form.createForm(this, { name: 'coordinated' }),
      formCategoryType  : this.$form.createForm(this, { name: 'coordinated' }),
      formCategoryTimes : this.$form.createForm(this, { name: 'coordinated' }),
      model             : null,
      model_category    : null,
      model_expense     : null,
      model_category_times: null,
      time              : 0,
      is_mode_edit      : false,
      is_add_expense_category: false,
      temp_row      : null,
      type_activity : null,
      type_category : 'all',
      expense_categories: [],
      time_categories: [],
      condition     : undefined,
      date          : undefined,
      stop_time     : true,
      matters       : [],
      category_expense : 1,
      category_type : null,
      row           : null,
      from_date     : null,
      to_date       : null,
      loadingCategory: false,
      optionSearchVendor:{
        placeholder: 'Search a vendor',
        label: 'Vendor',
        field: 'vendor',
        width: '100%',
        allow_clear: true
      },
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
      ]
    }
  },
  watch:{
    '$store.state.fetch_activity_tbl':{
      async handler(val){
        if(this.hasPermission('activity.time-entry.list')) {
          if(val){
            await this.$refs.Activities.fetch()
            this.$store.commit('FETCH_ACTIVITY', false)
            this.type_activity = '1'
          }
        }
      }
    }
  },
  methods:{

    rows(rows){

    },

    filterExpenseType(type){
      this.checkPagenation(this.$refs.expenseEntry)
      type === 'all' || type === undefined ? this.$refs.expenseEntry.query.query = [] : this.$refs.expenseEntry.query.query = [{ field:'expense_type',condition: '=',value: type  }]
      this.$refs.expenseEntry.fetch()
    },

    handleChangeExpense({target:{value:value}}){
      this.category_expense = value
      //this.expense_categories.filter(item => item.expense_type === value)
    },

    async getMatters(){
      const { data } = await axios.post('/matter/query/',{ limit: 9999 })
      this.matters   = data.rows
    },

    async handleMatterActivity(id){
      this.matter_value = id
      const matter = this.matters.find(item=>item.id === id) || {}
      if(matter && matter.hourly_rates.length && this.form.getFieldValue('user')){
        let user_rate = matter.hourly_rates.find(item=>item.user_id === this.form.getFieldValue('user')) || {}
        this.form.setFieldsValue({ rate: user_rate.rate.toFixed(2) })
      }else {
        this.form.setFieldsValue({ rate: this.is_mode_edit ? this.row.rate : this.form.getFieldValue('rate') || '0.00' })
      }
    },

    SelectUser(){
      this.handleMatterActivity(!this.is_mode_edit ? this.form.getFieldValue('matter') : this.row.matter_id)
    },

    startTime(){
      this.stop_time = false
      // if(this.form.getFieldValue('duration'))
      //   this.$refs.timer.formattedElapsedTime = this.form.getFieldValue('duration') * 3600
    },

    async filterDate(){
      const ref = this.type_activity === '1' ? 'Activities' : 'expenseEntry'
      const biggerDate   = (this.from_date ? { condition: '>=',value: this.from_date, field: 'date' } : undefined)
      const smallerDate  = (this.to_date ? { condition: '<=',value: this.to_date, field: 'date' } : undefined)
      this.$refs[ref].query.query = [biggerDate,smallerDate].filter(Boolean)
      await this.$refs[ref].fetch()
    },

    refresh(){
      this.type_category = 'all'
    },

    searchCategory(search){
      search === null || search === '' ? this.type_category = 'all' : this.type_category = 'none'
    },

    filterCategory(){
      this.type_category = 'none'
    },

    async filterStatus(value){
      this.checkPagenation(this.$refs.expenseCategory)
      value === 'all' ? this.$refs.expenseCategory.query.query = [] : this.$refs.expenseCategory.query.query = [{ field:'expense_type',condition:'=',value: value }]
      await this.$refs.expenseCategory.fetch()
    },

    showDrawer(refs){
      this.getCategoryExpense()
      refs.visible_drawer = true
    },

    setFieldRateQuantity(){
      const multiplication_rate_quantity = this.formEntry.getFieldValue('rate') * this.formEntry.getFieldValue('quantity')
      !isNaN(multiplication_rate_quantity) ?
        this.formEntry.setFieldsValue({ amount: Number(multiplication_rate_quantity).toFixed(2) }) :
        this.formEntry.setFieldsValue({ amount: undefined  })
    },

    setFieldAmount({target:{value}}){
      if(!isNaN(value))
        this.formEntry.setFieldsValue({rate: Number(value).toFixed(2), quantity:'1.00'})
    },

    editCategory(record,url,permission) {
      this.category_type = '3'
      this.clickTempRow(record,url,permission)
    },

    tabClick(key){
      this.type_activity = key
      this.type_category = 'all'
      // this.type_category = key === '1' ? 'all' : key
      this.to_date       = null
      this.from_date     = null
    },

    clickTempRow(record,url,permission){
      if (this.hasPermission(permission)) {
        this.is_add_expense_category = false
        this.is_mode_edit = true
        if(this.is_click_add_time && !record.is_used_in_invoice){
          this.temp_row = record
          if (this.type_activity === '1') this.openActivities = true
          if (this.type_activity === '2') this.openExpenseEntry = true
          if (this.type_activity === '3' || this.type_activity === '4') this.openCategoryType = true
          this.getCategoryExpense()
          this.getCategoryTimes()
          this.$nextTick(()=>this.getEntryTime(url))
        }else {
          this.$message.error('Activity has been billed and cannot be deleted or modified')
          this.is_click_add_time = true
        }
      }
    },

    selectExpenseType(value){
      if (this.openActivities) {
        const findCategoryTime = this.time_categories.find(item => item.id === value)
        this.form.setFieldsValue({ rate: findCategoryTime !== undefined ? findCategoryTime.rate : undefined })
      }else {
        const findCategoryExpense = this.expense_categories.find(item => item.id === value)
        this.formEntry.setFieldsValue({
          rate: findCategoryExpense !== undefined ? findCategoryExpense.rate : undefined,
          amount: findCategoryExpense !== undefined ? findCategoryExpense.rate * this.formEntry.getFieldValue('quantity') : undefined
        })
      }
    },

    async addActivities(){
      this.is_mode_edit = false
      this.openActivities = true
      await this.getCategoryTimes()
      const user = JSON.parse(localStorage.getItem('user'))
      if(user) this.form.setFieldsValue({ user: user.id })
    },

    addCategoryToExpense(){
      this.is_add_expense_category = true
      this.category_type = '3'
      this.addCategoryType()
    },

    addCategoryType(){
      this.is_mode_edit = false
      this.openCategoryType = true
    },

    onCancelCategoryType(){
      this.openCategoryType = false
      setTimeout(()=>this.formCategoryType.resetFields(),200)
    },

    onCancel(){
      this.openActivities = false
      this.$refs.timer.formattedElapsedTime = 0
      setTimeout(()=>this.form.resetFields(),200)
    },

    onCancelEntry(){
      this.openExpenseEntry = false
      setTimeout(()=>this.formEntry.resetFields(),200)
    },

    addActivitiesEntry(){
      this.is_mode_edit = false
      this.openExpenseEntry = true
      this.temp_row = null
      this.getCategoryExpense()
    },

    handleSubmit(){
      this.form.validateFields(async (err,values)=>{
        if(!err){
          try{
            this.$vs.loading()
            if(this.is_mode_edit){
              const { id } = this.temp_row
              this.matter_value ? values.matter = this.matter_value : !values.matter ? values.matter = null : values.matter = this.temp_row.matter.id
              await axios.put(`/activity/time-entry/${id}/`, values)
            }else {
              await axios.post(`/activity/time-entry/`, values)
            }
            this.openActivities = false
            this.$notification['success']({
              message: 'Success',
              description: `Time Entry ${this.is_mode_edit ? 'updated' : 'created'}.`,
            });
            this.type_activity = '1'
            this.form.resetFields()
            this.$refs.Activities.fetch().then(()=>{})
          }catch (e){
            this.$notification['error']({
              message: 'Error',
              description: `Please try again.`,
            });
          }finally {
            this.$vs.loading.close()
          }
        }
      })
    },

    handleSubmitExpense(){
      this.formEntry.validateFields(async(err,values)=>{
        if(!err){
          try{
            this.$vs.loading()
            values.quantity = Number(values.quantity)
            const value_expense_type = this.formEntry.getFieldValue('expense_type')
            if(value_expense_type === 2){
              values.vendor    = null
              values.reference = null
            }
            if(this.is_mode_edit){
              const { id } = this.temp_row
              if(this.category_expense === 1)
                this.matter_value ? values.matter = this.matter_value : !values.matter ? values.matter = null : values.matter = this.temp_row.matter.id
              else
                values.matter = null
              await axios.put(`/activity/expense-entry/${id}/`, values)
            }else{
              await axios.post('/activity/expense-entry/',values)
            }
              this.openExpenseEntry = false
              this.type_activity = '2'
              this.$notification['success']({
                message: 'Success',
                description: `Expense entry ${this.is_mode_edit ? 'updated' : 'created'}.`,
              });
              this.formEntry.resetFields()
              if (this.$refs.expenseEntry)
                await this.$refs.expenseEntry.fetch()
          }catch (e){
              this.$notification['error']({
                message: 'Failed',
                description: `Expense entry failed`,
              });
              throw e
          }finally {
              this.$vs.loading.close()
          }
        }
      })
    },

    handleCategoryType(){
      this.formCategoryType.validateFields(async(err,values)=>{
        if(!err){
          try{
            this.$vs.loading()
            values.billing_method = undefined
            const hasCategoryExpense = (this.category_type === '3')
            if(this.is_mode_edit){
              const {id} = this.temp_row
              await axios.put(hasCategoryExpense ? `/activity/expense-entry/category/${id}/` : `/activity/time-entry/category/${id}/`,values)
            }else
              await axios.post(hasCategoryExpense ? '/activity/expense-entry/category/' : '/activity/time-entry/category/',values)
            this.openCategoryType = false
            this.type_activity = (hasCategoryExpense ? '3' : '4')
            this.$notification['success']({
              message: 'Success',
              description: `category ${this.is_mode_edit ? 'updated' : 'created'}.`,
            });
            this.formCategoryType.resetFields()
              if(this.$refs[hasCategoryExpense ?'expenseCategory':'timesCategory'])
                this.$refs[hasCategoryExpense ?'expenseCategory':'timesCategory'].fetch().catch(() => {})
            if(this.is_add_expense_category){
              await this.getCategoryExpense()
              this.formEntry.setFieldsValue({ category: this.expense_categories[0].id })
              this.temp_row ? this.is_mode_edit = true : this.is_mode_edit = false
            }
          }catch (e){
            this.$notification['error']({
              message: 'Error',
              description: `Please Try again.`,
            });
            this.$vs.loading.close()
            throw e
          }finally {
            this.$vs.loading.close()
          }
        }
      })
    },

    // handleCategoryTimes() {
    //   this.formCategoryTimes.validateFields(async(err,values)=>{
    //     if(!err){
    //       try{
    //         this.$vs.loading()
    //         if(this.is_mode_edit){
    //           const {id} = this.temp_row
    //           await axios.put(`/activity/time-entry/category/${id}/`,values)
    //         }else
    //           await axios.post('/activity/time-entry/category/',values)
    //         this.openCategoryType = false
    //         this.$notification['success']({
    //           message: 'Success',
    //           description: `category ${this.is_mode_edit ? 'updated' : 'created'}.`,
    //         });
    //         this.formCategoryTimes.resetFields()
    //         this.$refs.timesCategory.fetch().then(()=>{})
    //         this.type_activity = '4'
    //       }catch (e){
    //         this.$notification['error']({
    //           message: 'Error',
    //           description: `PLease Try again.`,
    //         });
    //         this.$vs.loading.close()
    //         throw e
    //       }finally {
    //         this.$vs.loading.close()
    //       }
    //     }
    //   })
    // },

    getDataRow(data){
      if(this.type_activity === '1'){
        const second = data.duration * 3600
        this.$refs.timer.formattedElapsedTime = second
        this.time = data.duration
      }
      if(this.type_activity === '2'){
        data.expense_type === 1 ? this.category_expense = 1 : this.category_expense = 2
        data.vendor = (data.vendor !== null) ?  data.vendor.id : undefined
        if(data.amount === 0) data.amount = data.amount.toFixed(2)
        if(Number.isInteger(data.amount))   data.amount = data.amount.toFixed(2)
        if(Number.isInteger(data.quantity)) data.quantity = data.quantity.toFixed(2)
      }
      if(this.type_activity === '1' || this.type_activity === '2'){
        data.category ? data.category = data.category.id : data.category = undefined
        data.user   ? data.user   = data.user.id      : data.user = undefined
        data.date   = data.date   ? data.date         : new Date().toISOString()
      }
      if(data.rate === 0) data.rate = data.rate.toFixed(2)
      if(Number.isInteger(data.rate)) data.rate = data.rate.toFixed(2)
      data.matter_id = data.matter ? data.matter.id : undefined
      data.matter ? data.matter = data.matter.title : data.matter = undefined
      const which_form = (this.type_activity === '1' ? this.form : this.type_activity === '2' ? this.formEntry : this.formCategoryType)
      which_form.setFieldsValue(data)
    },

    async getEntryTime(url){
      try{
        this.$vs.loading()
        const { data } = await axios.get(url)
        this.row       = data
        await this.getDataRow(data)
      }catch (e){
        throw e
      }finally {
        this.$vs.loading.close()
      }
    },
    deleteTimeEntry(record){
      this.temp_row = record.id
      if (this.type_activity === '1') this.$refs.deleteTimeEntry.open       = true
      if (this.type_activity === '2') this.$refs.deleteExpenseEntry.open    = true
      if (this.type_activity === '3') this.$refs.deleteExpenseCategory.open = true
      if (this.type_activity === '4') this.$refs.deleteTimeCategory.open    = true
    },
    async getCategoryExpense() {
      try {
        this.loadingCategory = true
        const { data } = await axios.post('/activity/expense-entry/category/query/',{limit:100})
        this.expense_categories = data.rows
      } catch (e) {
        throw e
      } finally {
        this.loadingCategory = false
      }
    },
    async getCategoryTimes() {
      try {
        const { data } = await axios.post('/activity/time-entry/category/query/',{limit:100})
        this.time_categories = data.rows
      } catch (e) {
        throw e
      }
    },
    handleClickChange(e) {
      this.category_type = e.key
    },

    handleUsersLoaded(data) {
      const currentUser = JSON.parse(localStorage.getItem('user'))
      const found = data.filter(user => user.id === currentUser.id)
      if (found.length) {
        this.formEntry.setFieldsValue({ user: currentUser.id })
      }
    },
  },

  async created() {
    this.model                 = TableCol.default
    this.model_category        = TableColCategory.default
    this.model_expense         = TableColExpense.default
    this.model_category_times  = TableColCategoryTimes.default
  },
  async mounted() {
    this.is_click_add_time = true
    const permissions      = await this.$store.state.permissions
    if (permissions !== undefined) {
      if   (this.hasPermission('activity.time-entry.list')) this.type_activity = '1'
      else if(this.hasPermission('activity.expense-entry.list')) this.type_activity = '2'
      else if(this.hasPermission('activity.expense-entry.category.list')) this.type_activity = '3'
      else this.type_activity = '1'
    }else{
      this.type_activity = '1'
    }
    await this.getMatters()
    // await this.getCategoryTimes()
  },
}
</script>

<style>
  @import "../style/style.css";
  [dir] .ant-input{
    border-radius: 3px !important;
  }
  [dir=ltr] .ant-modal-footer{
    display: none !important;
  }
  [dir] .select .ant-select-selection.ant-select-selection--single{
    border-radius: 3px !important;
  }
  .vs-button--text{
    font-size: 13px;
    white-space: nowrap;
  }
  .vs-button.small{
    border-radius: 4px !important;
    padding: 8px !important;
  }
  /*[dir] .ant-form-item{*/
  /*  margin-bottom: 0 !important;*/
  /*}*/
  [dir] .ant-modal-title{
    color: #3A3DBE !important;
  }
  [dir] .vx-navbar-wrapper {
    z-index: 2 !important;
  }
  [dir] .ant-calendar-picker{
    width: 100%
  }
  .calenderSlotExtra{
    width: 50% !important;
  }
  .billing-method.ant-select-dropdown{
    z-index: 1501 !important;
  }
  @media (max-width: 600px) {
    .btn_add button{
      width: 100%;
    }
  }
</style>
